import React, { useEffect, useMemo, useRef, useState } from 'react';
import css from './LearnTheArabic.module.css';
import modernStandardMsa from '../../../../../assets/modern-standard-msa.png';
import { FormattedMessage } from 'react-intl';

  const tabs = [
    {
      key: 'msa',
      labelId: 'LearnTheArabic.tabs.msa.label',
      titleId: 'LearnTheArabic.tabs.msa.title',
      descId: 'LearnTheArabic.tabs.msa.desc',
      img: modernStandardMsa,
    },
    {
      key: 'Dialects',
      labelId: 'LearnTheArabic.tabs.Dialects.label',
      titleId: 'LearnTheArabic.tabs.Dialects.title',
      descId: 'LearnTheArabic.tabs.Dialects.desc',
      img: modernStandardMsa,
    },
    {
      key: 'Religious',
      labelId: 'LearnTheArabic.tabs.Religious.label',
      titleId: 'LearnTheArabic.tabs.Religious.title',
      descId: 'LearnTheArabic.tabs.Religious.desc',
      img: modernStandardMsa,
    },
  ];

  
function LearnTheArabic({ initialTab = 'msa' }) {
  const [active, setActive] = React.useState(
    tabs.find(t => t.key === initialTab)?.key || tabs[0].key
  );
  const current = tabs.find(t => t.key === active) || tabs[0];
  return (
    <div className={css.learnArabicWrapper}>
      <div className={css.arabicContainer}>
        <div className={css.arabicContent}>
          <h2 className={css.arabicHeading}>
            <FormattedMessage id="learnTheArabic.heading" />
          </h2>

          <div className={css.tabsRow}>
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                className={[
                  css.tabButton,
                  active === t.key ? css.tabActive : css.tabIdle,
                ].join(' ')}
                onClick={() => setActive(t.key)}
              >
                <FormattedMessage id={t.labelId} />
              </button>
            ))}
          </div>

          <div className={css.card}>
            <div className={css.cardText}>
              <h3 className={css.cardTitle}>
                <FormattedMessage id={current.titleId} />
              </h3>
              <p className={css.cardDesc}>
                <FormattedMessage id={current.descId} />
              </p>
            </div>
            <div className={css.cardMedia}>
              <img className={css.cardImg} src={current.img} alt={''} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LearnTheArabic;